module.exports = __webpack_public_path__ + "img/1440.aee487c2.jpg";